__turbopack_context__.v({
  "center": "noData-module-scss-module__Ff-INq__center",
  "wrapper": "noData-module-scss-module__Ff-INq__wrapper",
});
